import {Component, OnInit, AfterViewInit, ChangeDetectorRef, Renderer2} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OptionService } from "../option/option.service";

declare let window: any;
declare let __customFormAction: any;

@Component({
    selector: 'doi',
    templateUrl: './doi.component.html',
    providers: [OptionService],
    host: {
        '(window:resize)': 'resizeWindow($event)'
    }
})
export class DoiComponent implements OnInit, AfterViewInit{

    /**
     * holds the version of the output (widget|page|form)
     */
    version: string = "page";

    /**
     * holds the current step of the output
     * @type {string}
     */
    step: string = "doi";

    /**
     * The size that is available while using the application
     * @type {string}
     */
    size: string = "small";

    /**
     * The constructor
     * @param optionService
     * @param translate
     * @param changeDetector
     * @param renderer
     */
    constructor(private optionService: OptionService, private translate: TranslateService, private changeDetector: ChangeDetectorRef, protected renderer: Renderer2) {
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang("de");

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        let languageToUse: string = null;
        switch (translate.getBrowserLang()) {
            case "en":
                languageToUse = "en";
                break;
            case "de":
                languageToUse = "de";
                break;
            case "es":
                languageToUse = "es";
                break;
            case null:
            case "":
                // in case we do not know the language, use de
                languageToUse = "de";
                break;
            default:
                // in case we have a language but there is no translation available
                languageToUse = "en";
        }
        translate.use(languageToUse);
    }

    /**
     * Eventhandler that is called when the window is resized
     * @param event
     */
    resizeWindow(event: any = null): void {
        this.size = "small";
        if(window.innerWidth <= 580) {
            this.size = "small"
        }
        else if(window.innerWidth <= 768) {
            this.size = "medium"
        }
        else {
            this.size = "large"
        }

        // fire changes detection manually, other wise the button does not know what to do
        this.changeDetector.detectChanges();
        console.log("viewport change", this.size);
    }

    /**
     * method is called after the component has initialized with all its content
     */
    public ngAfterViewInit(): void {
        // check the screen size again
        this.resizeWindow(null);

        this.renderer.addClass(document.body, 'donation-app-loaded');
    }

    /**
     * onInit of the component
     */
    public ngOnInit(): any {
        // Init the resize function
        this.resizeWindow(null);
    }

    /**
     * Returns a text from the textstore or the project configuration
     * @param textKey
     * @returns {any|string|any}
     */
    getText(textKey: string): string {
        return this.optionService.getText(textKey);
    }
}
